import { render, staticRenderFns } from "./Power.vue?vue&type=template&id=d9871d5e&scoped=true"
import script from "./Power.vue?vue&type=script&lang=js"
export * from "./Power.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9871d5e",
  null
  
)

export default component.exports